import {Checkbox} from 'antd';
import React, {FC} from 'react';

import {TEntityValue} from 'modules/data';
import {getMatchesBoolValue} from 'modules/data/utils/data.utils';
import {normalizeBoolValue} from 'utils/common';

import './bool-field.less';

export interface IBoolFieldProps {
    value?: TEntityValue;
    onChange?: (value: any) => void;
    disabled?: boolean;
    referenceUrl?: string;
    entityName?: string;
    defaultValue?: string;
    label?: string;
}

export const BoolField: FC<IBoolFieldProps> = ({
    value,
    onChange,
    disabled,
    defaultValue,
    label,
    ...props
}: IBoolFieldProps) => {
    const handleChange = async () => {
        if (onChange) onChange(getMatchesBoolValue(value as string));
    };

    return (
        <>
            <Checkbox
                {...props}
                onChange={handleChange}
                checked={normalizeBoolValue(value || defaultValue)}
                disabled={!onChange || disabled}
            >{label}
            </Checkbox>
        </>
    );
};
